import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import { CSVLink } from 'react-csv';
import BikeTableHead from './BikeTableHead';
import BikeRow from './BikeRow';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { getBikeState } from '../../services/BikeService';
import { changeBikeTabAction } from '../../store/ui/actions';
import KobooButton from '../Layout/KobooButton';
import Loader from '../Layout/Loader';

const styles = () => (
  {
    table: {
      minWidth: 700,
    },
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
    paperTab: { width: '72%' },
  }
);

export class BikeTable extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    bikes: PropTypes.array.isRequired,
    isInBikePage: PropTypes.bool.isRequired,
    bike_tab: PropTypes.any.isRequired,
    changeBikeTabAction: PropTypes.func.isRequired,
    pending: PropTypes.bool.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'desc',
      orderBy: 'number',
      data: [],
      page: 0,
      rowsPerPage: 500,
      role: ROLE_USER,
      selectedTab: null,
      previousSelectedTab: null,
      bikeBase64: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    console.log(props.bikes);
    let newState = null;
    if (state.selectedTab === null) {
      newState = {
        ...newState,
        selectedTab: props.bike_tab,
      };
    }

    if (props.authUser && props.roles) {
      newState = {
        ...newState,
        role: props.roles[props.authUser.uid],
      };
    }

    if (props.bikes || state.selectedTab) {
      if (
        state.selectedTab === null
        || state.selectedTab !== state.previousSelectedTab
        || JSON.stringify(props.bikes).toString('base64') !== state.bikeBase64
      ) {
        let selectedData = [];
        const actualTab = state.selectedTab
          ? state.selectedTab
          : props.bike_tab;
        switch (actualTab) {
          case 0:
            selectedData = props.bikes;
            break;
          case 1:
            selectedData = props.bikes.filter(bike => bike.siteType === 0);
            break;
          case 2:
            selectedData = props.bikes.filter(bike => bike.siteType === 1);
            break;
          case 3:
            selectedData = props.bikes.filter(bike => bike.siteType === 2);
            break;
          case 4:
            selectedData = props.bikes.filter(bike => bike.siteType === 4);
            break;
          case 5:
            selectedData = props.bikes.filter(bike => bike.siteType === 5);
            break;
        }
        newState = {
          ...newState,
          page: 0,
          previousSelectedTab: actualTab,
          data: selectedData.sort((a, b) => BikeTable.sort(a, b, state.orderBy, state.order)),
          bikeBase64: JSON.stringify(props.bikes).toString('base64')
        };
      }
    }

    return newState;
  }

  static sort(a, b, property, order) {
    let prop1,
      prop2;
    if (property === 'bikeState') {
      prop1 = getBikeState(a);
      prop2 = getBikeState(b);
    } else if (property === 'rfid' || property === 'siteName') {
      prop1 = (
        a[property] !== null && a[property] !== undefined
      )
        ? a[property].toUpperCase()
        : '';
      prop2 = (
        b[property] !== null && b[property] !== undefined
      )
        ? b[property].toUpperCase()
        : '';
    } else {
      prop1 = (
        a[property] !== null && a[property] !== undefined
      )
        ? a[property]
        : -1;
      prop2 = (
        b[property] !== null && b[property] !== undefined
      )
        ? b[property]
        : -1;
    }
    if (order === 'asc') {
      return prop1 > prop2
        ? -1
        : 1;
    }
    return prop1 < prop2
      ? -1
      : 1;
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === orderBy && this.state.order === order) {
      order = 'asc';
    }
    const data = this.state.data.sort((a, b) => BikeTable.sort(a, b, orderBy, order));
    this.setState({
      data,
      order,
      orderBy,
    });
  };

  handleChangeTab = (event, value) => {
    this.props.changeBikeTabAction(value);
    this.setState({ selectedTab: value });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  datasForCSV = () => {
    let datas = [];
    for (let bike of this.state.data) {
      let data = Object();
      data['Numero'] = bike.number;
      data['Cadenas'] = bike.padlock_number;
      if (this.state.role === ROLE_ADMIN) {
        data['Loueur'] = bike.renterName;
      }
      data['Site'] = bike.siteName;
      data['Adresse MAC'] = bike.mac_address;
      data['RFID'] = bike.rfid;
      data['Etat'] = getBikeState(bike);
      datas.push(data);
    }
    return datas;
  };

  clickDownloadCsv = (event) => {
    event.stopPropagation();
    document.getElementById('csv_link_bike').click();
  };

  render() {
    const {
      classes,
      bikes,
      isInBikePage,
      pending,
    } = this.props;

    const {
      rowsPerPage,
      page,
      data,
      order,
      orderBy,
      role,
    } = this.state;
    return (
      <React.Fragment>
        <Grid
          container
          direction="row-reverse"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <KobooButton type="button" onClick={this.clickDownloadCsv}>
              Télécharger le CSV
            </KobooButton>
          </Grid>
        </Grid>
        <CSVLink
          id="csv_link_bike"
          filename={`velos-${new Date().getTime()}.csv`}
          data={this.datasForCSV()}
          style={{ display: 'none' }}
        >
          -
        </CSVLink>
        <div className={classes.tableWrapper}>
          {role === ROLE_ADMIN &&
          <Paper className={classes.paperTab}>
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="TOUS" />
              <Tab label="FREE FLOATING" />
              <Tab label="STATION" />
              <Tab label="MIXTE" />
              <Tab label="NOLOCK" />
              <Tab label="LLD" />
            </Tabs>
          </Paper>
          }
          <Table className={classes.table}>
            <BikeTableHead
              onRequestSort={this.handleRequestSort}
              order={order}
              orderBy={orderBy}
              rowCount={bikes.length}
              isInBikePage={isInBikePage}
            />
            <TableBody>
              {pending == true && <tr>
                <td colSpan={10}>
                  <Loader />
                </td>
              </tr>}
              {pending == false && data.length > 0 && data.slice(
                page * rowsPerPage,
                (
                  page * rowsPerPage
                ) + rowsPerPage,
              ).map(bike => (
                <BikeRow key={bike.id}
                         bike={bike}
                         isInBikePage={isInBikePage}
                />
              ))}
              {pending == false && data.length <= 0
              && <tr>
                <td colSpan={10}>
                  <Typography variant="subtitle1">Aucun vélo</Typography>
                </td>
              </tr>}
            </TableBody>
          </Table>

        </div>
        <KobooTablePagination
          numberOfItems={data.length}
          rowsPerPage={rowsPerPage}
          label="Vélos par page"
          page={page}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    bike_tab: state.ui.bike_tab,
  };
}

export default compose(
  connect(mapStateToProps, { changeBikeTabAction }),
  withStyles(styles),
)(BikeTable);



// WEBPACK FOOTER //
// ./src/components/Bike/BikeTable.jsx